import { Types } from '@store/types';

export const openLoader = () => {
	return (dispatch) => {
		dispatch({
			type: Types.OPEN_LOADER,
			payload: true
		});
	};
};

export const closeLoader = () => {
	return (dispatch) => {
		dispatch({
			type: Types.CLOSE_LOADER,
			payload: false
		});
	};
};
